import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

import { SearchParamKey } from '@app/store/appStore.types'


const useCollectSearchParams = (
    keys: SearchParamKey[],
    setSearchParams: (searchParams: Record<SearchParamKey, string | null>) => void,
    previousSearchParams?: Partial<Record<SearchParamKey, string | null>>,
) => {
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const params = {} as Record<SearchParamKey, string | null>
        let hasChanged = false

        keys.forEach((key) => {
            const value = searchParams.get(key) ?? previousSearchParams?.[key] ?? null
            params[key] = value
            if (previousSearchParams?.[key] !== value) {
                hasChanged = true
            }
        })

        if (hasChanged) {
            setSearchParams(params)
        }
    }, [keys, searchParams, setSearchParams, previousSearchParams])
}

export default useCollectSearchParams
